import APIRequest from './APIRequest';

export const GetFileUploadCredential = () => {
    return APIRequest({
        url: `Filesystem/GetFileUploadCredential`,
        method: 'post',
    })
}